import { ReactNode } from "react";
import { MModal } from "./mmodal";
import { MButton } from "./mbutton";

interface ConfirmModalProps {
  visible: boolean;
  title?: string;
  message: ReactNode;
  onCancel(): void;
  confirmButton: ReactNode;
}

export function ConfirmModal({
  visible,
  title,
  message,
  onCancel,
  confirmButton,
}: ConfirmModalProps) {
  return (
    <MModal
      visible={visible}
      onClose={onCancel}
      title={title}
      hideCloseIcon
      style={{ marginTop: "25vh" }}
      content={
        <div
          style={{
            fontSize: 16,
            textAlign: "center",
            lineHeight: 1.5,
            padding: "16px 0",
          }}
        >
          {message}
        </div>
      }
      footer={
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <MButton type="ghost" onClick={onCancel}>
            Annuller
          </MButton>
          {confirmButton}
        </div>
      }
    />
  );
}
